module.exports = __webpack_public_path__ + "static/img/phamthihoc.4167c81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phamthihoc.png
// module id = kzEr
// module chunks = 1